import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=a54d971e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=a54d971e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54d971e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a54d971e')) {
      api.createRecord('a54d971e', component.options)
    } else {
      api.reload('a54d971e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=a54d971e&scoped=true&", function () {
      api.rerender('a54d971e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o3vMBJpN8eFX/JS/comp/PopupDialog.vue"
export default component.exports